import React, { useState } from 'react';
import getStatusColor from '../../Helpers/GetStatusColor';
import Customer from '../../Pages/Contact/ContactDetails/index';
import './Details.css';
import CustomModal from '../CustomModal/CustomModal';
import { NewContactIcon } from '../../Assets/Navigation/NavigationIcons';
import DropshipIcon from '../../Assets/General/DropshipIcon';
import BackorderIcon from '../../Assets/General/BackorderIcon';
import { t } from 'i18next';

export const DetailsHeader = ({
  title = '',
  no = '',
  status = '',
  contactID = '',
  inModal = false,
  customer = '',
  type = null,
  utilizedCredits = 0,
  refundCredits = 0,
  actionMenu = () => null,
  myClass = '',
  Icon,
  // payment_type = '',
  track = '',
}) => {
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const contactCreateModal = () => {
    return (
      <CustomModal
        size="large"
        className="contacts_modal_view"
        showModal={showCustomerModal}
        title={t('Invoice.view_contact')}
        // minWidth={120}
        modaltitle="inventory_modal_title"
        Icon={NewContactIcon}
        renderActions={false}
        onClose={() => setShowCustomerModal(false)}
        linkTo={`contacts/${contactID}`}
      >
        <Customer id={contactID} inModal />
      </CustomModal>
    );
  };
  // console.log("title ==============================>" , t('Packages.package_no'));
  return (
    <div
      className={`details-header ${myClass} `}
      style={{ paddingLeft: '0rem' }}
    >
      {contactCreateModal()}
      <div className="details-header--title-info">
        <h3
          className="details-header--title"
          style={{
            color: '#33a348',
            fontWeight: '700',
            textTransform: 'uppercase',
            fontSize: '18px',
          }}
        >
          {title} {Icon && status !== 'not shipped' && <Icon />}
        </h3>

        <div>
          {customer && (
            <h5 className={!inModal ? 'customer_name' : ''}>
              {inModal ? (
                <u>{customer}</u>
              ) : (
                <div
                  className={!inModal ? 'pointer' : ''}
                  onClick={() => !inModal && setShowCustomerModal(true)}
                  to={`/contacts/${contactID}`}
                >
                  <u>{customer}</u>
                </div>
              )}
            </h5>
          )}
        </div>

        <div className="details-header--info d-inline">
          {(title === 'Sales Order' || title === '销售订单') && (
            <b>{t('common.sales_order_no')}</b>
          )}
          {(title === 'Packages' || title == '包裹') && (
            <b>{t('Packages.package_no')} </b>
          )}
          {title === 'Sales Return' && <b>{t('common.sales_return_no')} </b>}
          {(title === 'CREDIT NOTE' || title === '贷项通知单') && (
            <b>{t('CreditNote.cn_no')}</b>
          )}
          {(title === 'Purchase Order' || title === '采购订单') && (
            <b>{t('PurchaseOrder.purchase_order_no')}</b>
          )}
          {(title === 'Bill' || title === '账单') && (
            <b>{t('common.bill_no')}&nbsp;</b>
          )}
          {title === 'Payment Details' && (
            // payment_type === 'invoice_payment' &&
            <b>{t('common.payment_no')}</b>
          )}
          {title === 'Payment Details' ? <span>{no}</span> : no}
          {track && (
            <div style={{ marginTop: '10px' }}>
              <span
                className="status status--confirmed"
                style={{ marginLeft: '0' }}
              >
                {track == 'Direct'
                  ? t('Items.direct')
                  : track == 'Advance'
                  ? t('Items.advance')
                  : track == 'consumed'
                  ? t('Items.consumed')
                  : track}
              </span>
            </div>
          )}
          <div className="float-left w-100" style={{ marginTop: '10px' }}>
            {title === 'Sales Return' && (
              <span
                style={{ margin: '0' }}
                className={
                  status === 'receiving'
                    ? getStatusColor('partially received')
                    : status === 'closed'
                    ? getStatusColor('received')
                    : getStatusColor(status)
                }
              >
                {status === 'receiving'
                  ? t('Items.receiving')
                  : status === 'closed'
                  ? t('Items.receiving')
                  : status === 'confirmed'
                  ? t('saleOrder.filter_options.confirmed')
                  : status === 'consumed'
                  ? t('Items.consumed')
                  : status === 'open'
                  ? t('Items.open')
                  : status}
              </span>
            )}
            {title !== 'Sales Return' && (
              <span style={{ margin: '0' }} className={getStatusColor(status)}>
                {status === 'partially paid'
                  ? t('Items.partially_paid')
                  : status === 'partially applied'
                  ? t('Items.partially_applied')
                  : status === 'draft'
                  ? t('Items.draft')
                  : status === 'issued'
                  ? t('Items.issued')
                  : status === 'closed'
                  ? t('Items.closed')
                  : status === 'confirmed'
                  ? t('saleOrder.filter_options.confirmed')
                  : status === 'not shipped'
                  ? t('Packages.pkg_status.not_shipped')
                  : status === 'delivered'
                  ? t('Packages.pkg_status.delivered')
                  : status === 'shipped'
                  ? t('Packages.pkg_status.shipped')
                  : status === 'open'
                  ? t('Items.open')
                  : status === 'onhold'
                  ? t('report.salesOrder.statusOptions.onhold')
                  : status === 'consumed'
                  ? t('Items.consumed')
                  : status === 'cancelled'
                  ? t('Items.cancelled')
                  : status === 'paid'
                  ? t('Items.paid')
                  : status === 'overdue'
                  ? t('Items.overdue')
                  : status === 'received'
                  ? t('Items.received')
                  : status}
              </span>
            )}
            {type && (type === 'dropship' || type === 'dropshipped') && (
              <div title={t('common.dropship')} className="dropshipicon-set">
                {' '}
                <DropshipIcon />
              </div>
            )}
            {type && (type === 'backorder' || type === 'backordered') && (
              <div title={t('common.backorder')} className="dropshipicon-set">
                {' '}
                <BackorderIcon />
              </div>
            )}
          </div>
          {title === 'CREDIT NOTE' && (
            <ul className="credit_status_row">
              {utilizedCredits > 0 && (
                <div className="credit_status">
                  <span className="dot"></span>
                  <li>{t('common.paid_on_invoice')}</li>
                </div>
              )}
              {refundCredits > 0 && (
                <div className="credit_status">
                  <span className="dot"></span>
                  <li>{t('common.refunded')}</li>
                </div>
              )}
            </ul>
          )}
        </div>
      </div>
      <div className="details-header--action">{actionMenu()}</div>
    </div>
  );
};
